import { render, staticRenderFns } from "./TakipAltTipList.vue?vue&type=template&id=ebe41cae"
import script from "./TakipAltTipList.vue?vue&type=script&lang=ts"
export * from "./TakipAltTipList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports